import React from "react";
import { useLocation } from "react-router-dom";
import { FiUser, FiSettings, FiBell, FiSearch } from "react-icons/fi";
import "../../assets/style/Header.css";

const Header = () => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/") return "Dashboard";
    return path.substring(1).charAt(0).toUpperCase() + path.substring(2);
  };

  return (
    <div className="argon-header">
      <div className="header-left">
        <h1 className="page-title">{getPageTitle()}</h1>
      </div>

      {/* <div className="header-right">
        <div className="search-bar">
          <FiSearch className="search-icon" />
          <input type="text" placeholder="Type here..." />
        </div>
        <div className="header-icons">
          <FiUser title="Sign In" />
          <span className="signin-text">Sign In</span>
          <FiSettings title="Settings" />
          <FiBell title="Notifications" />
        </div>
      </div> */}
    </div>
  );
};

export default Header;
